import styled, { keyframes } from "styled-components";
import { colors } from "../../../styles/colors";

const bounce = keyframes`
  0%, 80%, 100% {
    transform: scale(0.3);
    opacity: 0.3;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
`;

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 ${colors.teal}40;
  }
  70% {
    box-shadow: 0 0 0 10px ${colors.teal}00;
  }
  100% {
    box-shadow: 0 0 0 0 ${colors.teal}00;
  }
`;

export const SpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 20px;
  
  span {
    color: ${colors.blueGray};
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.5px;
    text-align: center;
  }
`;

export const Spinner = styled.div<{ size: "small" | "medium" | "large" }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ size }) => {
    switch (size) {
      case "small": return "6px";
      case "large": return "12px";
      default: return "8px";
    }
  }};
`;

export const SpinnerDot = styled.div<{ $delay: number }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: linear-gradient(135deg, ${colors.teal} 0%, ${colors.blue} 100%);
  animation: ${bounce} 1.4s ease-in-out infinite both, ${pulse} 2s infinite;
  animation-delay: ${({ $delay }) => $delay}s;
  box-shadow: 0 2px 12px ${colors.teal}30;
  transition: all 0.3s ease;
  
  ${Spinner}[size="small"] & {
    width: 8px;
    height: 8px;
  }
  
  ${Spinner}[size="large"] & {
    width: 16px;
    height: 16px;
  }
  
  &:hover {
    transform: scale(1.1);
  }
`;